import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/shared";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Onboarding from "@/pages/Onboarding";
import ControlTower from "@/pages/ControlTower";
import Pipeline from "@/pages/Pipeline";
import Contacts from "@/pages/Contacts";
import Diagnostic from "@/pages/Diagnostic";
import Pricing from "@/pages/Pricing";
import Proposals from "@/pages/Proposals";
import Engagements from "@/pages/Engagements";
import Workspace from "@/pages/Workspace";
import Finder from "@/pages/Finder";
import Academy from "@/pages/Academy";
import Profile from "@/pages/Profile";

const CLIENT_ROLES = ["client_admin", "client_contributor"];

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) return <div className="min-h-screen"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (CLIENT_ROLES.includes(user.role)) {
    return <Navigate to={`/workspace/${user.workspace_engagement_id}`} replace />;
  }
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Login register />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/workspace/:eid" element={<Workspace />} />
          <Route path="/" element={<Protected><ControlTower /></Protected>} />
          <Route path="/pipeline" element={<Protected><Pipeline /></Protected>} />
          <Route path="/finder" element={<Protected><Finder /></Protected>} />
          <Route path="/academy" element={<Protected><Academy /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/contacts" element={<Protected><Contacts /></Protected>} />
          <Route path="/diagnostic" element={<Protected><Diagnostic /></Protected>} />
          <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
          <Route path="/proposals" element={<Protected><Proposals /></Protected>} />
          <Route path="/engagements" element={<Protected><Engagements /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
